<template>
  <loading-overlay v-if="loading" class="animated fadeIn" />

  <div v-else class="animated fadeIn">
    <default-heading text="Time Series Report" class="mt-3">
      <template #right>
        <b-button v-if="report_data" variant="success" class="ml-1" @click="download">
          <i class="fal fa-download" />
        </b-button>
      </template>
    </default-heading>

    <div>
      <div v-if="report_data && report_data.data" ref="report" class="p-3">
        <TimeSeriesReport :report="report_data.data" :chart_type="chart_type" />
      </div>

      <TimeSeriesReportForm
        v-else
        :set_customer_grower="customer_grower"
        @submit="submit"
        @setChartType="(chartType) => {
          chart_type = chartType
        }"
      />
    </div>
  </div>
</template>

<script>
import DefaultHeading from '@/components/shared/DefaultHeading'
import TimeSeriesReportForm from '@/components/modus/result/TimeSeriesReportForm.vue';
import SampleResultModel from '@/models/result/SampleResultModel';
import TimeSeriesReport from '../../components/modus/result/TimeSeriesReport.vue';
import { downloadHtmlCanvas } from '../../shared/utils';
import LoadingOverlay from '@/components/shared/LoadingOverlay'
import CustomerGrowerModel from '@/models/crm/CustomerGrowerModel'

export default {
  name: 'CustomerGrowerTimeSeriesReport',
  components: {
    DefaultHeading,
    TimeSeriesReportForm,
    TimeSeriesReport,
    LoadingOverlay
  },
  data () {
    return {
      loading: true,
      customer_grower_id: this.$route.params.id || null,
      customer_grower: null,
      customer_id: this.$store.getters.getAuthCustomerID,
      report_data: null,
      chart_type: 'bar'
    }
  },
  async mounted () {
    await this.fetchCustomerGrower()
    this.loading = false
  },
  methods: {
    async fetchCustomerGrower () {
      const model = new CustomerGrowerModel({ id: this.customer_grower_id })

      return model.fetch().then(() => {
        this.customer_grower = model
      })
    },

    async submit (form_data) {
      try {
        const model = new SampleResultModel()
        const { response } = await model.getTimeSeries({
          ...form_data,
          customer_id: this.customer_id
        })

        if (response && response.status === 200 && response.data) {
          this.report_data = response.data
        }
      } catch (error) {
        console.error(error)
      }
    },

    download() {
      const { report } = this.$refs;
      const fileName = `time-series-report.pdf`;
      downloadHtmlCanvas(report, fileName);
    }
  }
}
</script>
